import axios from 'axios';

export default {
  namespaced: true,
  actions: {
    async updateVisibility({ commit, rootState }, args){
      const params = {
        visible: args.visible
      }

      const authUser = rootState.AuthFirebase.auth.currentUser;

      const config = {
        headers: {
          Authorization: `Bearer ${await authUser.getIdToken()}`
        }
      };

      return await axios
        .patch(process.env.VUE_APP_EDUCACIONIT_API_SERVER + "contactos/me", params, config)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          return error.response;
        });
    }
  }
};
